import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-business-content',
  templateUrl: './business-content.component.html',
  styleUrls: ['./business-content.component.css']
})
export class BusinessContentComponent implements OnInit    {
 
 

  private subscription: Subscription;
    message: any;
    constructor() { }
 
  



  ngOnInit() {
  }

}
